import { LAYOUT } from '/@/router/constant';

const test = {
  path: '/test',
  name: 'Test',
  component: LAYOUT,
  redirect: '/test/index',
  meta: {
    hideChildrenInMenu: true,
    title: '测试',
    orderNo: 30333,
  },
  children: [
    {
      path: 'index',
      name: 'TestPage',
      component: () => import('/@/views/sys/test/index.vue'),
      meta: {
        title: '测试',
        hideMenu: true,
      },
    },
  ],
};

export default test;
